import React, {useMemo} from 'react';
import {Link, useParams} from 'react-router-dom';
import {useGetMeshes, useGetProjects} from 'api/generated';
import {Button, ProgressBar} from 'components';
import {useMe} from 'hooks';

interface IHomePlanUsageProps {}

const HomePlanUsage = ({}: IHomePlanUsageProps) => {
  const params = useParams();
  const workspace = params.workspace ?? '';

  const me = useMe();

  const {data: projectsData} = useGetProjects({filter: 'mine'}, {query: {staleTime: 5 * 1000}});
  const projects = projectsData?.data?.data ?? [];

  const {data: meshesData} = useGetMeshes({filter: 'mine'}, {query: {staleTime: 5 * 1000}});
  const meshes = meshesData?.data?.data ?? [];

  const features = me?.plan?.featuresOverride || me?.plan?.features;

  const projectsMax = useMemo(() => {
    const value = features?.find(f => f?.id === 'projects')?.value ?? 0;
    return typeof value === 'number' ? value : 0;
  }, [features]);

  const modelsMax = useMemo(() => {
    const value = features?.find(f => f?.id === 'models')?.value ?? 0;
    return typeof value === 'number' ? value : 0;
  }, [features]);

  return (
    <div className="flex flex-col-reverse sm:flex-row items-center justify-between gap-x-6">
      <div className="flex flex-col sm:flex-row items-center gap-6 w-full mt-2">
        <ProgressBar progress={projects.length} progressMax={projectsMax} progressSuffix="" size="small" progressText="Projects Limit" />
        <ProgressBar progress={meshes.length} progressMax={modelsMax} progressSuffix="" size="small" progressText="Models Limit" />
      </div>
      <Link to={`/${workspace}/billing/plans`} className="whitespace-nowrap mb-5 sm:mb-0">
        <Button text={`${me?.plan?.name} plan`} size="small" />
      </Link>
    </div>
  );
};

export default React.memo(HomePlanUsage);
